/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// Caminho antigo da aba no legado (router.tsx:606-641): abre o detalhe com a aba em `?tab=` (U42).
export const Route = createFileRoute('/_app/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/contas-digitais/solicitacoes/$bankAccountId', params, search: { tab: 'acessos-concedidos' } });
  },
});
